import Image from "@/atoms/Image";
import Para from "@/atoms/text/Para";

export default function ListOverBgImg({ data: { listData, bgImg, stats } }) {
  return (
    <div className="mt-10-d mt-7">
      {listData && (
        <ul className="ps-r percent-wrapper pr-8-d pl-8-d pr-4 pl-4">
          {listData.map((info, idx) => (
            <li
              key={idx}
              className={`percent-li tc-white fx fx--cv-d ${
                idx === listData.length - 1 ? "" : "mb-1"
              } ${info.bgColor ? `bc-${info.bgColor}` : ""}`}
            >
              <span className="title title--md-d title--sm sec-font bold">
                {info.percent}
                <sub className="title title--xs">%</sub>
              </span>
              <Para
                color="white"
                className="pl-3-d pl-1"
                dangerouslySetInnerHTML={{ __html: info.context }}
              />
            </li>
          ))}
        </ul>
      )}
      {bgImg && (
        <div className="ps-r bg-offset-top">
          <Image
            fileName={bgImg.fileName}
            fileFormat="png"
            desktopWidth={bgImg.desktopWidth}
            mobileWidth={bgImg.mobileWidth}
            alt={bgImg.altText}
          />
          {stats && (
            <Para
              className="bg-stats"
              color="grey-dark"
              desktopSize="sm"
              mobileSize="sm"
              dangerouslySetInnerHTML={{ __html: stats }}
            ></Para>
          )}
          <style global jsx>{`
            .bg-offset-top {
              margin-top: -316px;
            }
            .bg-stats {
              position: absolute;
              left: 60px;
              bottom: 40px;
            }
            @media (max-width: 1199px) {
              .bg-offset-top {
                margin-top: -276px;
              }
              .bg-stats {
                color: white;
                left: initial;
                right: 16px;
                bottom: 14px;
              }
            }
            .percent-wrapper {
              max-width: 560px;
              z-index: 2;
            }
            .percent-li {
              padding: 24px 20px;
              border-radius: 8px;
            }
            @media (max-width: 1199px) {
              .percent-li {
                padding: 16px;
              }
            }
          `}</style>
        </div>
      )}
    </div>
  );
}
